import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../styles/Dashboard.css";
import UserComponent from "../superAdmin/UserComponent";
import EditProfileForm from "./EditProfileForm";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handleUpdateUser } from "../../../store/actions/userActions";
// Removed unused tenant list actions
// import { handleUpdateUser } from "../store/actions/userActions";
import { handleGetAdminData, handleGetCompanyData } from "../../../store/actions/adminActions";
const EditAdminProfile = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { adminList } = useSelector((state) => state.admin);
  const { user, userProfile } = useSelector((state) => state.user);
  const adminId = user?.id;
  const role = user?.role;

  useEffect(() => {
    const companyId = user?.company?.id;
    if (adminId) {
      if ((role === "admin" || role === "manager") && companyId) {
        // For admin users, fetch company data (includes company users)
        dispatch(handleGetCompanyData(companyId));
      } else if (role === "admin" || role === "manager") {
        // Fallback to admin data if companyId not available
        dispatch(handleGetAdminData(adminId));
      } else if (role === "superadmin") {
        // superadmin specific logic if needed
      }
    }
  }, [dispatch, adminId, role, user]);
  //   const { user } = useSelector((state) => state.user);
  const [isEditing, setIsEditing] = useState(false); // State to toggle edit mode

  const userData = {
    name: userProfile?.data?.manager?.name || "", //TODO: change to admin data
    email: userProfile?.data?.manager?.email || "",
    city: userProfile?.data?.manager?.city || "",
    address: userProfile?.data?.manager?.address || "",
    country: userProfile?.data?.manager?.country || "",
    joinedDate: userProfile?.data?.manager?.created_at || "",
    mobile_number: userProfile?.data?.manager?.mobile_number || "",
    role: userProfile?.data?.manager?.role || "",
  };
  const userDetailsArray = [
    { label: "Name", value: userData.name },
    { label: "Email", value: userData.email },
    { label: "Address", value: userData.address },
    { label: "City", value: userData.city },
    { label: "Country", value: userData.country },
    { label: "Role", value: userData.role },
  ];

  const handleEdit = () => {
    setIsEditing(true); // Set edit mode to true when edit icon is clicked
  };
  const handleFormSubmit = async (updatedData) => {
    await handleUpdateUser(user.id, updatedData, dispatch);
    // Logic to update the user data
    setIsEditing(false); // Exit edit mode after submission
  };

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          {isEditing ? (
            <EditProfileForm
              user={userData}
              onSubmit={handleFormSubmit}
              onCancel={() => setIsEditing(false)}
            />
          ) : (
            <UserComponent
              user={userData}
              userDetails={userDetailsArray}
              onEdit={handleEdit}
            />
          )}{" "}
          {/* Toggle view */}
        </Col>
      </Row>
    </Container>
  );
};

export default EditAdminProfile;
